// Универсальное появление элементов при скролле (см. anim.styl).
// Наблюдаем .anim-group (родитель-триггер) и одиночные .anim-item вне групп;
// при входе во вьюпорт вешаем .is-visible. Модификатор --no-hide (на группе
// или элементе) — раскрыть один раз и оставить; иначе повторяется.

let observer = null;
let targets = [];

export function initReveal() {
	// Наблюдаем: группы-родители + одиночные .anim-item, которые НЕ внутри группы
	// (внутри группы дети управляются классом .is-visible на самом родителе).
	targets = [
		...document.querySelectorAll(".anim-group"),
		...Array.from(document.querySelectorAll(".anim-item")).filter(
			(el) => !el.closest(".anim-group")
		),
	];
	if (!targets.length) return;

	// нет IntersectionObserver — просто показываем всё
	if (!("IntersectionObserver" in window)) {
		targets.forEach((el) => el.classList.add("is-visible"));
		return;
	}

	observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				const el = entry.target;
				const once = el.className.includes("--no-hide");

				if (entry.isIntersecting) {
					el.classList.add("is-visible");
					if (once) observer.unobserve(el);
				} else if (!once) {
					el.classList.remove("is-visible");
				}
			});
		},
		{
			// Линия-триггер: анимация включается, когда ВЕРХНЯЯ граница элемента
			// зашла во вьюпорт на 20% высоты экрана (пересекла линию на 80% от верха).
			// Нижний отступ root = -(100 - 20)% ; threshold 0 = ловим момент пересечения.
			rootMargin: "0px 0px -20% 0px",
			threshold: 0,
		}
	);

	targets.forEach((el) => observer.observe(el));
}

// Сброс: скрыть все появления и снова начать наблюдение — чтобы при повторном
// открытии (возврат к выбору языка) анимации проиграли заново с нуля.
export function resetReveal() {
	if (!observer) return;
	targets.forEach((el) => {
		el.classList.remove("is-visible");
		observer.observe(el); // повторно наблюдаем (в т.ч. --no-hide, снятые ранее)
	});
}
